import React from 'react';

const ExperienceSection = () => {
  return (
    <section className="experience_list_section">
      <div className="section-bg-images">
        <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/88-bell.svg')" }} data-aos="flip-left" data-aos-delay="100" data-aos-duration="800"></div>
        <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/99-semicircle.svg')" }} data-aos="flip-right" data-aos-delay="200" data-aos-duration="1000"></div>
        <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/12-circle-outline.svg')" }} data-aos="flip-up" data-aos-delay="300" data-aos-duration="1200"></div>
        <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/85-wave.svg')" }} data-aos="flip-down" data-aos-delay="400" data-aos-duration="1400"></div>
        <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="rotate-left" data-aos-delay="500" data-aos-duration="800"></div>
        <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/92-infinity.svg')" }} data-aos="rotate-right" data-aos-delay="600" data-aos-duration="1000"></div>
        <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/77-badge.svg')" }} data-aos="fade-up" data-aos-delay="700" data-aos-duration="1200"></div>
        <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/84-rounded-leaf.svg')" }} data-aos="fade-down" data-aos-delay="800" data-aos-duration="1400"></div>
        <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/42-hexagon.svg')" }} data-aos="fade-left" data-aos-delay="900" data-aos-duration="800"></div>
      </div>
      <div className="container">
        <div className="comingsoon-body-item block-item">
          <div className="experience_list experience_list_1bececf">
            <div className="experience_list_wrap">
              <div className="row">
                <div className="col-lg-3 col-sm-6" data-aos="zoom-in" data-aos-delay="100">
                  <div className="experience_list_single text-center">
                    <div className="experience_list_count">
                      <span className="counterUp number1">500</span>
                      <span className="plus">+</span>
                    </div>
                    <div className="count-text">Projects Completed</div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6" data-aos="zoom-in" data-aos-delay="250">
                  <div className="experience_list_single text-center">
                    <div className="experience_list_count">
                      <span className="counterUp number2">350</span>
                      <span className="plus">+</span>
                    </div>
                    <div className="count-text">Happy Clients</div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6" data-aos="zoom-in" data-aos-delay="400">
                  <div className="experience_list_single text-center">
                    <div className="experience_list_count">
                      <span className="counterUp number3">8</span>
                      <span className="plus">+</span>
                    </div>
                    <div className="count-text">Services Offered</div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6" data-aos="zoom-in" data-aos-delay="550">
                  <div className="experience_list_single text-center">
                    <div className="experience_list_count">
                      <span className="counterUp number4">15</span>
                      <span className="plus">+</span>
                    </div>
                    <div className="count-text">Years Experience</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
